import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-414d88b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "account_info" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " NAME ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " NICKNAME ", -1))
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "input_box" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xi-check" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xi-close" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xi-pen" }, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " EMAIL ", -1))
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, " AWARD ", -1))
const _hoisted_18 = {
  key: 0,
  class: "benefit"
}
const _hoisted_19 = ["disabled"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "xi-angle-right" }, null, -1))

import { ref, watch } from 'vue';
import { storeToRefs } from 'pinia';

import { BenefitsType } from '@/interface/member';
import BENEFITS from '@/common/constants';
import useCommonStore from '@/store/storeCommon';
import useMemberStore from '@/store/storeMember';



export default /*#__PURE__*/_defineComponent({
  __name: 'AccountInfo',
  setup(__props) {

const { accessedMemberInfo, getLevelName, accessEditNickname } = useMemberStore();
const { editNickname } = storeToRefs(useMemberStore());
const { isMobile, isImageMode, isMainLogo, isSatelliteInfo } = storeToRefs(useCommonStore());
const { disabledQualification, inputValueAni, showPanel, showModal, modalContents } = useCommonStore();

const inputBoxInputEl = ref<HTMLInputElement | null>(null);
const accessToken = localStorage.getItem('accessToken') || sessionStorage.getItem('accessToken');

watch(inputBoxInputEl, (input) => {
  if (input) {
    input.focus();
    input.value = accessedMemberInfo.nickname;
    if (input.value) {
      input.parentElement?.classList.add('active');
    } else {
      input.parentElement?.classList.remove('active');
    }
  }
});

/**
 * 수정한 nickname을 저장합니다.
 */
const submitNickname = async (): Promise<void> => {
  try {
    const response = await accessEditNickname(editNickname.value, accessToken);

    if (response) {
      const { nickname } = response;
      accessedMemberInfo.nickname = nickname;
      showPanel.isEditNickname = false;
      editNickname.value = '';

      isMainLogo.value = true;
      isSatelliteInfo.value = false;

      showModal.isSuccess = true;
      Object.assign(modalContents, {
        title: 'Success!',
        description: '닉네임 변경이 성공하였습니다.',
      });
    }
  } catch (e) {
    console.log(e);
  }
};

/**
 * 'BENEFITS'에 저장된 정보에 따른 혜택이 각각의 등급에 따라 필터되어 보여집니다.
 * @param lists
 */
const benefitsList = (lists: BenefitsType[]): string[] => {
  switch (accessedMemberInfo.level) {
    case '데브라':
    case '메테':
    case '코롱이':
      const levelBenefits = lists.filter(list => list.level === accessedMemberInfo.level);
      return levelBenefits[0].benefits;
    case '관리자':
      return ['ADMIN'];
    default:
      return ['GUEST'];
  }
};

/**
 * 닉네임 수정 Input을 활성화 합니다.
 */
const editNicknameOpen = (): void => {
  showPanel.isEditNickname = true;
  if (editNickname.value) {
    editNickname.value = '';
  }
};

/**
 * 조건별 함수
 */
const qualificationFunction = (qualification: string): boolean => {
  switch (qualification) {
    case 'showAccountInfo':
      return (showPanel.isAccountInfo || showPanel.isMobileAccountInfo) && !isImageMode.value;
    case 'showBenefits':
      return accessedMemberInfo.level === '데브라' || accessedMemberInfo.level === '메테' || accessedMemberInfo.level === '코롱이';
    case 'disabledEditNickname':
      return !editNickname.value || accessedMemberInfo.nickname === editNickname.value;
    default:
      return false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(getLevelName)())
  }, [
    (qualificationFunction('showAccountInfo'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(["account", {'mobile_account' : _unref(isMobile)}])
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", null, [
                _hoisted_3,
                _createElementVNode("span", null, _toDisplayString(_unref(accessedMemberInfo).name), 1)
              ]),
              _createElementVNode("div", null, [
                _hoisted_4,
                (_unref(showPanel).isEditNickname)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _withDirectives(_createElementVNode("input", {
                          class: "edit_nickname_input",
                          type: "text",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(editNickname) ? (editNickname).value = $event : null)),
                          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(inputValueAni) && _unref(inputValueAni)(...args))),
                          ref_key: "inputBoxInputEl",
                          ref: inputBoxInputEl
                        }, null, 544), [
                          [_vModelText, _unref(editNickname)]
                        ]),
                        _createElementVNode("button", {
                          type: "button",
                          title: "확인",
                          disabled: qualificationFunction('disabledEditNickname'),
                          class: _normalizeClass({ opacity : qualificationFunction('disabledEditNickname') }),
                          onClick: submitNickname
                        }, _hoisted_9, 10, _hoisted_7),
                        _createElementVNode("button", {
                          class: "edit_nickname_cancel",
                          type: "button",
                          title: "취소",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(showPanel).isEditNickname = false))
                        }, _hoisted_11)
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_12, [
                      _createTextVNode(_toDisplayString(_unref(accessedMemberInfo).nickname) + " ", 1),
                      _createElementVNode("button", {
                        type: "button",
                        title: "수정",
                        onClick: editNicknameOpen
                      }, _hoisted_14)
                    ]))
              ]),
              _createElementVNode("div", null, [
                _hoisted_15,
                _createElementVNode("span", null, _toDisplayString(_unref(accessedMemberInfo).email), 1)
              ]),
              (_unref(accessedMemberInfo).award)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _hoisted_17,
                    _createElementVNode("span", null, _toDisplayString(_unref(accessedMemberInfo).award), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            (qualificationFunction('showBenefits'))
              ? (_openBlock(), _createElementBlock("ul", _hoisted_18, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(benefitsList(_unref(BENEFITS)), (benefit, index) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `benefit_${index}`
                    }, _toDisplayString(benefit), 1))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ], 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("button", {
      type: "button",
      class: "password_edit_btn",
      style: {"pointer-events":"auto"},
      disabled: _unref(disabledQualification)(),
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(showPanel).isEditPassword = true))
    }, [
      _createTextVNode(" 비밀번호 변경 "),
      _hoisted_20
    ], 8, _hoisted_19)
  ], 2))
}
}

})